import { TeslaAutocompleteComponent } from '@tesla/angular2-tesla-common/autocomplete/autocomplete.component';
import { AppSettings } from 'src/app/app.settings';
import { Component, OnInit, Input, AfterViewInit, QueryList, ViewChild } from '@angular/core';
import { PartInfo } from 'src/app/models/partinfo';
import { ProposalService } from 'src/app/services/proposal.service';
import { Observable, of } from 'rxjs';
import { GridData, DataStateChangeEvent } from '@tesla/angular2-tesla-common/grid/grid.models';
import Helper from 'src/app/core/utility/helper';
import { PartBasicInfo } from 'src/app/models/partbasicinfo';
import { DataService } from 'src/app/services/data.service';
import { Router } from '@angular/router';
import { ReviewProposalPartInfo } from 'src/app/models/internal/reviewproposalpartinfo2';
import * as moment from 'moment/moment';
import { UpdateProposalStatusDTO } from 'src/app/models/internal/updateproposalstatusdto';
import { Constants } from 'src/app/core/constants';
import { ToastService } from 'src/app/services/toaster/toaster.service';
import { BaseGridPage } from 'src/app/core/basepages/allbasepages';
import { TeslaGridComponent } from '@tesla/angular2-tesla-common/tesla-common';
import { tap } from 'rxjs/operators';
import { SearchFilter } from 'src/app/models/internal/searchfilter';
import { QueryByStatusDTO } from 'src/app/models/internal/query-bystatus-dto';
import { LocalstorageService } from 'src/app/services/localstorage.service';
import { FormGroup, FormBuilder } from '@angular/forms';
import { UserData } from '../../../models/auth/userdata';
import { SelectedAutocompleteValue } from '@tesla/angular2-tesla-common/autocomplete/autocomplete.model';
import { SourceType } from 'src/app/models/sourcetype';
import { PartSystemDTO } from 'src/app/models/external/partsystem-dto';
import { NGXLogger } from 'ngx-logger';
import { ICanExportData } from 'src/app/core/interfaces/can-export-data.interface';
import UIHelper from 'src/app/core/utility/ui-helper';
import { PackageType } from 'src/app/models/packagetype';

@Component({
    selector: 'app-reivewproposallist',
    templateUrl: './reivewproposallist.component.html',
    styleUrls: ['./reivewproposallist.component.scss'],
})
export class ReviewproposallistComponent extends BaseGridPage implements OnInit, AfterViewInit, ICanExportData {
    excelFilenamePrefix = "ReviewProposals_";
    appSettings: AppSettings;
    partProposalInfoList: ReviewProposalPartInfo[];
    partInfoIds: number[];
    isTeslaCreatedList: any[] = [];
    isInboundShipment: boolean = true;
    allItemsCheckBoxSelected: boolean = false;
    updateProposalStatusDTO = new UpdateProposalStatusDTO();
    autoCompletePEURL: string;
    searchSupplierURL: string;
    atLeastOneFieldError: boolean = false;
    filterForm: FormGroup;
    engineerDisplay: string;
    @ViewChild('PEAutoComplete') PEAutoComplete: TeslaAutocompleteComponent;
    @ViewChild('SupplierAutoComplete') SupplierAutoComplete: TeslaAutocompleteComponent;
    sourceTypeList: SourceType[];
    partSystemList: PartSystemDTO[];
    packageTypeList: PackageType[];
    IsConditionalApproval = [{ text: 'True', value: 1 }, { text: 'False', value: 0 }];
    Demand_Status = [{ text: 'Past', value: 'P' }, { text: 'Future', value: 'F' }, { text: 'Current', value: 'C' }, { text: 'No Demand', value: 'N' }];
    TeslaEquipmentCode: string;
    WorkflowStatusId = [{ text: 'Submitted', value: 2 },{ text: 'Pending Validation', value: 5 }, { text: 'Incomplete', value: 6 }, { text: 'Approved', value: 4 }, { text: 'Rejected', value: 3 }];

    constructor(
        private dataService: DataService,
        private proposalService: ProposalService,
        localstorageService: LocalstorageService,
        private router: Router,
        private fb: FormBuilder,
        private toastService: ToastService,
        logger: NGXLogger,
        appSettings: AppSettings,
    ) {
        super(localstorageService, logger, appSettings);
        this.filterForm = this.fb.group({
            PartNumber: [null],
            PartDescription: [null],
            SupplierCode: [null],
            IsTeslaCreated: [null],
            EffectiveFrom: [null],
            CreatedOn: [null],
            EngineerUserId: [null],
            SourceTypeId: [null],
            PartCategoryId: [null],
            IsTeslaUpdated: [false],
            PackageTypeId: [null],
            IsConditionalApproval: [null],
            Demand_Status: [null],
            TeslaEquipmentCode: [null],
            WorkflowStatusId: [null]
        });

        this.isTeslaCreatedList.push({'Description': 'Yes', 'Value': 1});
        this.isTeslaCreatedList.push({'Description': 'No', 'Value': 0});
        this.appSettings = appSettings;
        this.autoCompletePEURL = this.appSettings.Packaging2APIUrl + '/peassignment/pe/all';
        this.searchSupplierURL = this.appSettings.Packaging2APIUrl + '/externaldata/supplier/all';


    }

    //tms-29146 Due to performance, Launch review proposal screen as blank without any filtered records based on logged in PE value.
    ngOnInit() {
        this.filterForm.controls['Demand_Status'].setValue(this.Demand_Status[2].value);
        this.filterForm.controls['WorkflowStatusId'].setValue(this.WorkflowStatusId[0].value);
        let userId: string =  this.localstorageService.retrieve(Constants.storageSettingKeys.STORAGE_SETTING_WARP_USER_ID);
        let userDisplayName: string = this.localstorageService.retrieve(Constants.localStorageKeys.UserDisplayName);
        if (!userId && !userDisplayName) {
          this.dataService.getMe().subscribe((response: any) => {
            if (response != null && response['Data'] != null && response['Data'][0] != null) {
                userId = response['Data'][0]['UserId'];
                userDisplayName = response['Data'][0]['DisplayName'];
                this.filterForm.controls['EngineerUserId'].patchValue(userId);
                this.PEAutoComplete.selected = new SelectedAutocompleteValue();
                this.PEAutoComplete.selected.Description = userDisplayName;
            }
          });
        } else {
          this.filterForm.controls['EngineerUserId'].patchValue(userId);
          this.PEAutoComplete.selected = new SelectedAutocompleteValue();
          this.PEAutoComplete.selected.Description = userDisplayName;
        }

        this.getSourceTypes();
        this.getPartSystems();
        this.getPackageTypes();
        this.initFilterValues();
    }

    fillGrid(): void {
        this.filter.Skip = this.skip;
        this.filter.Take = this.pageSize;
        this.allItemsCheckBoxSelected = false;
        this.getReviewProposals();
    }
    UpdateFilter() {
        this.filter.SearchFilterConditions = [];
        this.filter = this.setFilterCondition(this.filter, this.filterForm, 'PartNumber', Constants.FILTER_DATATYPE_STRING,  Constants.FILTER_OPERATOR_TYPE_LIKE);
        this.filter = this.setFilterCondition(this.filter, this.filterForm, 'PartDescription', Constants.FILTER_DATATYPE_STRING,  Constants.FILTER_OPERATOR_TYPE_LIKE);
        this.filter = this.setFilterCondition(this.filter, this.filterForm, 'SupplierCode', Constants.FILTER_DATATYPE_STRING,  Constants.FILTER_OPERATOR_TYPE_EQUAL);
        this.filter = this.setFilterCondition(this.filter, this.filterForm, 'IsTeslaCreated', Constants.FILTER_DATATYPE_NUMBER,  Constants.FILTER_OPERATOR_TYPE_EQUAL);
        this.filter = this.setFilterCondition(this.filter, this.filterForm, 'EffectiveFrom', Constants.FILTER_DATATYPE_DATETIME,  Constants.FILTER_OPERATOR_TYPE_EQUAL);
        this.filter = this.setFilterCondition(this.filter, this.filterForm, 'CreatedOn', Constants.FILTER_DATATYPE_DATETIME,  Constants.FILTER_OPERATOR_TYPE_EQUAL);
        this.filter = this.setFilterCondition(this.filter, this.filterForm, 'EngineerUserId', Constants.FILTER_DATATYPE_NUMBER,  Constants.FILTER_OPERATOR_TYPE_EQUAL);
        this.filter = this.setFilterCondition(this.filter, this.filterForm, 'SourceTypeId', Constants.FILTER_DATATYPE_NUMBER,  Constants.FILTER_OPERATOR_TYPE_EQUAL);
        this.filter = this.setFilterCondition(this.filter, this.filterForm, 'PartCategoryId', Constants.FILTER_DATATYPE_NUMBER,  Constants.FILTER_OPERATOR_TYPE_EQUAL);
        this.filter = this.setFilterCondition(this.filter, this.filterForm, 'IsTeslaUpdated', Constants.FILTER_DATATYPE_NUMBER,  Constants.FILTER_OPERATOR_TYPE_EQUAL);
        this.filter = this.setFilterCondition(this.filter, this.filterForm, 'PackageTypeId');
        this.filter = this.setFilterCondition(this.filter, this.filterForm, 'IsConditionalApproval', Constants.FILTER_DATATYPE_NUMBER, Constants.FILTER_OPERATOR_TYPE_EQUAL);
        this.filter = this.setFilterCondition(this.filter, this.filterForm, 'Demand_Status', Constants.FILTER_DATATYPE_STRING, Constants.FILTER_OPERATOR_TYPE_EQUAL);
        this.filter = this.setFilterCondition(this.filter, this.filterForm, 'TeslaEquipmentCode', Constants.FILTER_DATATYPE_STRING,  Constants.FILTER_OPERATOR_TYPE_LIKE);
        this.filter = this.setFilterCondition(this.filter, this.filterForm, 'WorkflowStatusId', Constants.FILTER_DATATYPE_NUMBER, Constants.FILTER_OPERATOR_TYPE_EQUAL);
    }
    clearFilter() {
        this.PEAutoComplete.selected.Description = '';
        this.filterForm.reset();
        this.filterForm.controls['IsTeslaUpdated'].setValue(false);
        this.filter.SearchFilterConditions = [];
        this.localSearch();
    }
    exportData()
    {
        const filename = this.excelFilenamePrefix + Helper.formatDateTime(new Date()) + '.xlsx';
        const queryByStatusDTO: QueryByStatusDTO = new QueryByStatusDTO();
        queryByStatusDTO.SearchFilter = this.filter;
        queryByStatusDTO.WorkflowStatusId = Constants.WORKFLOW_STATUS_SUBMITTED;
        this.dataService.getProposalsForReviewExcel(queryByStatusDTO).subscribe((response: any) => {
            if (response != null && response.Success) {
                UIHelper.DownloadExcelFile(response.Data, filename);
            } else {
                this.toastService.error(
                    'Could not export data'
                );
            }
        });
    }
    deleteProposal(proposalId) {
            if (Helper.confirmDeleteAction()) {
                this.dataService.deleteProposal(proposalId).subscribe((response: any) => {
                    if (response != null && response.Success) {
                        this.toastService.success('Proposal deleted successfully', true);
                        this.fillGrid();
                    } else {
                        this.toastService.error(
                            'Could not delete the proposal'
                        );
                    }
                });
            } else {
            this.toastService.info('You cancelled the delete request');
            }
        }
    getReviewProposals() {
        this.UpdateFilter();
        const queryByStatusDTO: QueryByStatusDTO = new QueryByStatusDTO();
        queryByStatusDTO.SearchFilter = this.filter;
        queryByStatusDTO.WorkflowStatusId = Constants.WORKFLOW_STATUS_SUBMITTED;
        this.dataService
            .getProposalsForReview(queryByStatusDTO)
            .subscribe((response: any) => {
                // this.partInfo = response
                if (response != null) {
                    this.partProposalInfoList = response.Data;
                    this.gridView = of({
                        data: response.Data,
                        total: response.Total ? response.Total : 0,
                    });
                }
                if (this.partProposalInfoList.length === 0) {
                    this.mainGrid = undefined;
                }
            });
    }

    getPackageType(packageTypeId) {
        return Helper.getPackageTypeDescription(packageTypeId);
    }

    formatDate(unformattedDate: Date) {
        return Helper.formatDate(unformattedDate);
    }

    getEffectiveTo(unformattedDate: Date) {
        const futureDate = new Date(
            moment()
                .add(5, 'years')
                .calendar()
        );
        if (unformattedDate <= futureDate) {
            return Helper.formatDate(unformattedDate);
        } else {
            return 'End of time';
        }
    }

    reviewProposal(id: number) {
        this.proposalService.RefreshproposalToReviewId(id);
        window.open('pe-proposalsnapshot/' + id, '_blank');
        // this.router.navigate(['../', 'pe-proposalsnapshot']).then(result => {  window.open(['../', 'pe-proposalsnapshot'], '_blank'); });
        // this.router.navigate(['../', 'pe-proposalsnapshot']);
    }

    onRowSelectedChange(isSelected: boolean, partInfo: PartInfo) {
        if (isSelected) {
            this.partProposalInfoList.find(
                a => a.Id === partInfo.Id
            ).IsSelected = true;
            if (
                this.partProposalInfoList.filter(a => a.IsSelected === true)
                    .length === this.partProposalInfoList.length
            ) {
                this.allItemsCheckBoxSelected = true;
            }
        } else {
            this.partProposalInfoList.find(
                a => a.Id === partInfo.Id
            ).IsSelected = false;
            this.allItemsCheckBoxSelected = false;
        }
        this.proposalService.RefreshpartInfoToBeCreatedList(
            this.partProposalInfoList
        );
    }

    setAllSelected(isSelected: boolean) {
        // this.partinfoList.map(function(part) {
        //     part.IsSelected = isSelected;
        //     return part;
        // });
        this.partProposalInfoList.forEach(part => {
            part.IsSelected = isSelected;
        });
        this.proposalService.RefreshpartInfoToBeCreatedList(
            this.partProposalInfoList
        );
    }

    getAllSelectedOrNot(getSelected: boolean): number[] {
        return this.partProposalInfoList
            .filter(a => a.IsSelected === getSelected)
            .map(prop => prop.Id);
    }

    // RejectProposals() {
    //     this.updateProposalStatusDTO.WorkflowStatusId =
    //         Constants.WORKFLOW_STATUS_REJECTED;
    //     this.updateProposalStatusDTO.ProposalId = this.getAllSelectedOrNot(
    //         true
    //     );
    //     this.logDebug(this.updateProposalStatusDTO);
    //     this.updateProposalStatus();
    // }
    // ApproveProposals() {
    //     this.updateProposalStatusDTO.WorkflowStatusId =
    //         Constants.WORKFLOW_STATUS_APPROVED;
    //     this.updateProposalStatusDTO.ProposalIds = this.getAllSelectedOrNot(
    //         true
    //     );
    //     this.logDebug(this.updateProposalStatusDTO);
    //     this.updateProposalStatus();
    // }

    getStatusDescription(workflowStatusId: number): string{
        return 'Status: ' + Helper.getProposalStatusDescription(workflowStatusId);
    }

    updateProposalStatus() {
        this.dataService
            .updateProposalsStatus(this.updateProposalStatusDTO)
            .subscribe(data => {
                // this.partInfo = data
                if (data != null) {
                    // console.log(data);
                    this.toastService.success(
                        'Proposal Status ' + Constants.SUCCESS_SAVE_GENERIC
                    );
                }
            });
    }
    ValidateForm() {
        // console.log(this.gridData);
    }

    onEmptyPE(eventObj: any): void {
        this.filterForm.controls['EngineerUserId'].patchValue(null);
        this.PEAutoComplete.list = [];
        if (this.filter != null && this.filter.SearchFilterConditions != null && this.filter.SearchFilterConditions.findIndex(x => x.Field === 'EngineerUserId') >= 0) {
            this.filter.SearchFilterConditions.splice(this.filter.SearchFilterConditions.findIndex(x => x.Field === 'EngineerUserId'), 1);
        }
    }
    onEmptySupplierCode(eventObj: any): void {
        this.filterForm.controls['SupplierCode'].patchValue(null);
        this.SupplierAutoComplete.list = [];
        if (this.filter != null && this.filter.SearchFilterConditions != null && this.filter.SearchFilterConditions.findIndex(x => x.Field === 'SupplierCode') >= 0) {
            this.filter.SearchFilterConditions.splice(this.filter.SearchFilterConditions.findIndex(x => x.Field === 'SupplierCode'), 1);
        }
    }

    getSourceTypes() {
        this.dataService.getParentSourceTypes().subscribe((response: any) => {
            if (response && response.Data != null) {
                this.sourceTypeList = response.Data;
            }
        });
      }

      getPartSystems() {
        this.dataService.getPartSystems().subscribe((response: any) => {
                if (response != null && response.Success) {
                    this.partSystemList = response.Data;
                    // this.partSystemList = this.excludeAlreadyAssignedPartSystems(this.partSystemList);
                }
            });
    }

    getPackageTypes() {
        this.dataService.getPackageTypes().subscribe((response: any) => {
            if (response && response.Data != null) {
                this.packageTypeList = response.Data;
            }
        });
    }

    hasUserEnterAnyValue() {
        const controls = this.filterForm.controls;
        if (!controls) return true;

        const anyFieldHasValue = Object.keys(controls).filter(key => key != "PackageTypeId").some(key => controls[key].value);
        return anyFieldHasValue;
    }

    localSearch() {
        this.atLeastOneFieldError = false;
        if(!this.hasUserEnterAnyValue()) {
            this.atLeastOneFieldError = true;
            return;
        }

        this.search();
    }
}

